import { PropsWithChildren, useMemo, useReducer } from 'react';
import {
  SplitPaymentsContext,
  SplitPaymentsState,
  SplitPaymentsStateAction,
  DEFAULT_SPLIT_PAYMENTS_STATE,
} from './context';

const reducer = (
  state: SplitPaymentsState,
  action: SplitPaymentsStateAction,
) => {
  switch (action.type) {
    case 'ADD_PAYMENT_METHOD':
      return {
        ...state,
        paymentMethods: [...state.paymentMethods, action.payload],
      };
    case 'UPDATE_PAYMENT_METHOD': {
      const { index, paymentMethod } = action.payload;
      const newPaymentMethods = [...state.paymentMethods];
      if (!newPaymentMethods[index]) return state;
      newPaymentMethods[index] = {
        ...newPaymentMethods[index],
        ...paymentMethod,
      };
      return {
        ...state,
        paymentMethods: newPaymentMethods,
      };
    }
    case 'RESET':
      return DEFAULT_SPLIT_PAYMENTS_STATE;
    case 'SET_SPLIT_PAYMENTS_GROUP':
      return {
        ...state,
        splitPaymentsGroup: action.payload,
      };
    case 'SET_CURRENT_INDEX':
      return {
        ...state,
        currentIndex: action.payload,
      };
    case 'SET_PAYMENT_COLLECTED': {
      const { index, isPaymentCollected } = action.payload;
      const newPaymentMethods = [...state.paymentMethods];
      if (!newPaymentMethods[index]) return state;
      newPaymentMethods[index].isPaymentCollected = isPaymentCollected;
      return {
        ...state,
        paymentMethods: newPaymentMethods,
      };
    }
    case 'SET_FORM':
      return {
        ...state,
        form: action.payload,
      };
    default:
      return state;
  }
};

export function SplitPaymentsProvider({ children }: PropsWithChildren) {
  const [state, dispatch] = useReducer(reducer, DEFAULT_SPLIT_PAYMENTS_STATE);

  const contextValue = useMemo(
    () => ({
      state,
      dispatch,
    }),
    [state, dispatch],
  );

  return (
    <SplitPaymentsContext.Provider value={contextValue}>
      {children}
    </SplitPaymentsContext.Provider>
  );
}
